module.exports = __webpack_public_path__ + "img/tele.d8180ed2.svg";